(function () {
  if (window.__collectionCardEnhancedV3) return;
  window.__collectionCardEnhancedV3 = true;

  var productCache = new Map();

  function getProduct(handle) {
    if (!productCache.has(handle)) {
      productCache.set(
        handle,
        fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          if (!r.ok) throw new Error('product fetch failed');
          return r.json();
        })
      );
    }
    return productCache.get(handle);
  }

  function findSizeOptionIndex(product) {
    var keys = ['size', 'taille', 'tailles', 'pointure'];
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = (typeof opts[i] === 'string' ? opts[i] : (opts[i] && opts[i].name) || '').toLowerCase();
      if (keys.indexOf(name) !== -1) return i;
    }
    return -1;
  }

  function imageUrl(src, width) {
    if (!src) return '';
    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function ensureScrubber(item) {
    if (item.dataset.scrubberInit) return Promise.resolve();
    item.dataset.scrubberInit = 'pending';
    var handle = item.dataset.productHandle;
    if (!handle) return Promise.resolve();

    return getProduct(handle)
      .then(function (product) {
        var media = (product.media || []).slice(0, 6);
        var imgs = media.length
          ? media.map(function (m) { return m.preview_image && m.preview_image.src ? m.preview_image.src : m.src; })
          : (product.images || []).slice(0, 6);
        imgs = imgs.filter(Boolean);
        if (imgs.length < 2) return;

        var wrapper = item.querySelector('.card__media');
        var cardEl = item.querySelector('.card--product') || item.querySelector('.card');
        if (!wrapper || !cardEl) return;

        var primary = wrapper.querySelector('picture:first-of-type img') || wrapper.querySelector('img');
        if (!primary) return;

        // Snapshot original responsive attributes so we can restore on mouseleave
        var originalSrc = primary.currentSrc || primary.src;
        var originalSrcset = primary.getAttribute('srcset') || '';
        var originalSizes = primary.getAttribute('sizes') || '';
        var picture = primary.closest('picture');
        var sourceSnapshots = [];
        if (picture) {
          picture.querySelectorAll('source').forEach(function (s, i) {
            sourceSnapshots[i] = { el: s, srcset: s.getAttribute('srcset') || '', sizes: s.getAttribute('sizes') || '' };
          });
        }

        // Dots indicator
        var dots = document.createElement('div');
        dots.className = 'collection-card__dots';
        for (var i = 0; i < imgs.length; i++) {
          var s = document.createElement('span');
          if (i === 0) s.classList.add('is-active');
          dots.appendChild(s);
        }
        cardEl.appendChild(dots);
        var spans = dots.querySelectorAll('span');

        // Preload all images
        imgs.forEach(function (u) {
          var im = new Image();
          im.src = imageUrl(u, 720);
        });

        var currentIdx = 0;
        var scrubLocked = false;
        var lockTimeout = null;

        function applyUrl(url) {
          // Neutralize responsive sources so our chosen URL wins
          if (picture) {
            picture.querySelectorAll('source').forEach(function (sEl) {
              sEl.removeAttribute('srcset');
              sEl.removeAttribute('data-srcset');
            });
          }
          primary.removeAttribute('srcset');
          primary.removeAttribute('data-srcset');
          primary.setAttribute('sizes', '100vw');
          primary.src = url;
        }

        function restoreOriginal() {
          if (sourceSnapshots.length) {
            sourceSnapshots.forEach(function (snap) {
              if (snap.srcset) snap.el.setAttribute('srcset', snap.srcset);
              if (snap.sizes) snap.el.setAttribute('sizes', snap.sizes);
            });
          }
          if (originalSrcset) primary.setAttribute('srcset', originalSrcset);
          if (originalSizes) primary.setAttribute('sizes', originalSizes);
          primary.src = originalSrc;
        }

        function setImage(idx) {
          currentIdx = ((idx % imgs.length) + imgs.length) % imgs.length;
          applyUrl(imageUrl(imgs[currentIdx], 720));
          primary.dataset.scrubIdx = String(currentIdx);
          for (var j = 0; j < spans.length; j++) {
            if (j === currentIdx) spans[j].classList.add('is-active');
            else spans[j].classList.remove('is-active');
          }
        }

        function lockScrub() {
          scrubLocked = true;
          if (lockTimeout) clearTimeout(lockTimeout);
          lockTimeout = setTimeout(function () { scrubLocked = false; }, 800);
        }

        // Nav arrows
        var prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'collection-card__nav collection-card__nav--prev';
        prev.setAttribute('aria-label', 'Image précédente');
        prev.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="15 6 9 12 15 18"/></svg>';

        var next = document.createElement('button');
        next.type = 'button';
        next.className = 'collection-card__nav collection-card__nav--next';
        next.setAttribute('aria-label', 'Image suivante');
        next.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="9 6 15 12 9 18"/></svg>';

        function handleArrowClick(dir, e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          setImage(currentIdx + dir);
          lockScrub();
          item.classList.add('is-scrubbing');
        }
        prev.addEventListener('click', function (e) { handleArrowClick(-1, e); });
        next.addEventListener('click', function (e) { handleArrowClick(1, e); });
        // Block pointer events from bubbling up to the underlying <a>
        ['mousedown', 'pointerdown', 'touchstart'].forEach(function (ev) {
          prev.addEventListener(ev, function (e) { e.stopPropagation(); });
          next.addEventListener(ev, function (e) { e.stopPropagation(); });
        });

        cardEl.appendChild(prev);
        cardEl.appendChild(next);

        // Mousemove scrubber
        wrapper.addEventListener('mousemove', function (e) {
          if (scrubLocked) return;
          var rect = wrapper.getBoundingClientRect();
          var pct = (e.clientX - rect.left) / rect.width;
          var idx = Math.max(0, Math.min(imgs.length - 1, Math.floor(pct * imgs.length)));
          if (primary.dataset.scrubIdx !== String(idx)) setImage(idx);
          item.classList.add('is-scrubbing');
        });

        wrapper.addEventListener('mouseleave', function () {
          if (scrubLocked) return;
          restoreOriginal();
          primary.dataset.scrubIdx = '';
          for (var j = 0; j < spans.length; j++) {
            if (j === 0) spans[j].classList.add('is-active');
            else spans[j].classList.remove('is-active');
          }
          currentIdx = 0;
          item.classList.remove('is-scrubbing');
        });

        item.dataset.scrubberInit = 'done';
      })
      .catch(function (e) {
        item.dataset.scrubberInit = 'error';
        console.warn('[collection-card] scrubber init failed', e);
      });
  }

  function ensureSizePanel(item) {
    if (item.dataset.sizePanelInit) return Promise.resolve();
    item.dataset.sizePanelInit = 'pending';

    var handle = item.dataset.productHandle;
    if (!handle) return Promise.resolve();

    return getProduct(handle)
      .then(function (product) {
        var card = item.querySelector('.card--product') || item.querySelector('.card');
        if (!card) return;

        var panel = card.querySelector('.collection-card__size-panel');
        if (!panel) {
          panel = document.createElement('div');
          panel.className = 'collection-card__size-panel';
          card.appendChild(panel);
        }

        var sizeIdx = findSizeOptionIndex(product);
        var entries = [];
        var seen = {};

        if (sizeIdx >= 0) {
          var optKey = 'option' + (sizeIdx + 1);
          for (var i = 0; i < product.variants.length; i++) {
            var v = product.variants[i];
            var size = v[optKey];
            if (!size || seen[size]) continue;
            seen[size] = true;
            entries.push({ label: size, variantId: v.id, available: v.available });
          }
        } else if (product.variants && product.variants.length > 1) {
          for (var k = 0; k < product.variants.length; k++) {
            var vv = product.variants[k];
            entries.push({ label: vv.title, variantId: vv.id, available: vv.available });
          }
        } else if (product.variants && product.variants.length === 1) {
          entries.push({ label: 'Ajouter', variantId: product.variants[0].id, available: product.variants[0].available });
        }

        entries.forEach(function (e) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'collection-card__size-btn';
          btn.textContent = e.label;
          btn.setAttribute('data-variant-id', String(e.variantId));
          if (!e.available) btn.disabled = true;
          btn.addEventListener('click', function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            addToCart(btn, e.variantId);
          });
          panel.appendChild(btn);
        });

        item.dataset.sizePanelInit = 'done';
      })
      .catch(function (e) {
        item.dataset.sizePanelInit = 'error';
        console.warn('[collection-card] size panel init failed', e);
      });
  }

  function addToCart(btn, variantId) {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    var body = {
      items: [{ id: Number(variantId) || variantId, quantity: 1 }],
      sections: 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble',
      sections_url: window.location.pathname
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (e) {
            throw new Error((e && (e.description || e.message)) || 'add failed ' + r.status);
          });
        }
        return r.json();
      })
      .then(function (state) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1200);

        var item = btn.closest('.collection-card-enhanced');
        if (item) item.classList.remove('is-size-open');

        var miniCart = document.querySelector('mini-cart');
        if (miniCart && typeof miniCart.renderContents === 'function') {
          try {
            miniCart.renderContents(state);
            return;
          } catch (err) {
            console.warn('[collection-card] mini-cart.renderContents failed, falling back', err);
          }
        }

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'collection-card', cart: state }); } catch (e) {}
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          if (typeof drawer.openMenuDrawer === 'function') drawer.openMenuDrawer();
          else if (typeof drawer.open === 'function') drawer.open();
        }
      })
      .catch(function (e) {
        btn.classList.remove('is-loading');
        btn.classList.add('has-error');
        setTimeout(function () { btn.classList.remove('has-error'); }, 2000);
        console.error('[collection-card] add to cart failed', e);
      });
  }

  function bindItem(item) {
    if (item.dataset.enhancedBound) return;
    item.dataset.enhancedBound = 'true';

    var trigger = item.querySelector('.collection-card__size-trigger');
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        ensureSizePanel(item).then(function () {
          item.classList.toggle('is-size-open');
        });
      });
    }

    item.addEventListener('mouseenter', function () {
      ensureScrubber(item);
      ensureSizePanel(item);
    });

    item.addEventListener('focusin', function () {
      ensureSizePanel(item);
    });
  }

  function init(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('.collection .product-grid .flex-grid__item[data-product-handle]');
    items.forEach(bindItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('collection:reloaded', function () { init(); });
  document.addEventListener('shopify:section:load', function () { init(); });

  var grid = document.getElementById('ProductGridContainer');
  if (grid) {
    var mo = new MutationObserver(function () { init(); });
    mo.observe(grid, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var open = document.querySelectorAll('.collection-card-enhanced.is-size-open');
    open.forEach(function (it) {
      if (!it.contains(e.target)) it.classList.remove('is-size-open');
    });
  });
})();
